import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useMemo } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { loadOTErrcode } from 'console/redux/opentherm-errcodes/actions';
import { select_opentherm_error_description } from 'console/redux/opentherm-errcodes/reducer';
import { pad0 } from 'webui/utils/number';
import { getOpenThermStateName } from 'openTherm';
import { OTErrorDescriptionLink } from './description-link';
import { OTErrorDialog } from './dialog';
import { Box, Typography } from '@mui/material';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const OTErrorBlock = memo(function OTErrorBlock(props) {
    const { ot, boiler_model, title, onClick, ba_protocol } = props;
    const [errDialogOpen, closeErrDialog, openErrDialog] = useBooleanState(false);
    const fault_flags = ot.ff;
    const errorLoadingState = useAppSelector((state) => boiler_model != null
        ? select_opentherm_error_description(state, boiler_model, ot)
        : null);
    const loadDescription = useAction(loadOTErrcode);
    useEffect(() => {
        if (boiler_model != null && errorLoadingState == null) {
            loadDescription(boiler_model, ba_protocol, ot);
        }
    }, [boiler_model, ot, loadDescription, fault_flags]);
    const oem_code = errorLoadingState?.result?.display_as != null
        ? `Код ошибки ${errorLoadingState.result.display_as}`
        : fault_flags?.c != null
            ? `Код ошибки E${pad0(fault_flags.c, 2)}`
            : null;
    const ot_error_flags = useMemo(() => (fault_flags?.f ?? []).map((flag) => getOpenThermStateName(flag, 'ru')), [fault_flags?.f]);
    return (_jsxs(Box, { sx: {
            '&:not(:first-of-type)': {
                mt: 1,
            },
        }, onClick: onClick, children: [title != null && _jsx(Typography, { variant: "h6", children: title }), oem_code && _jsx(Typography, { variant: "subtitle1", children: oem_code }), boiler_model != null &&
                fault_flags?.c != null &&
                (errorLoadingState?.loading ? (_jsx(Typography, { variant: "subtitle2", children: _jsx("i", { children: "\u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u043E\u0448\u0438\u0431\u043A\u0438..." }) })) : errorLoadingState?.result != null ? (_jsxs(Box, { children: [_jsx(OTErrorDescriptionLink, { spec: errorLoadingState.result, onOpenErrorDialog: openErrDialog }), _jsx(OTErrorDialog, { open: errDialogOpen, oem_code: oem_code, spec: errorLoadingState.result, onClose: closeErrDialog })] })) : null), ot_error_flags.map((title, i) => (_jsx(Typography, { variant: "body1", children: title }, i)))] }));
});
